module.exports = __webpack_public_path__ + "img/www.flipkart.com.ca36ec67.png";